/**
 * @generated SignedSource<<87cb6e46d56079ede01e5c473bcd4102>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WaitlistBookings_Agenda$data = {
  readonly queueSlot: {
    readonly bookings: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly request?: {
            readonly time: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"WaitlistBooking_Booking">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "WaitlistBookings_Agenda";
};
export type WaitlistBookings_Agenda$key = {
  readonly " $data"?: WaitlistBookings_Agenda$data;
  readonly " $fragmentSpreads": FragmentRefs<"WaitlistBookings_Agenda">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Request",
    "kind": "LinkedField",
    "name": "request",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "time",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "queueSlot",
          "bookings"
        ]
      }
    ]
  },
  "name": "WaitlistBookings_Agenda",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueSlot",
      "kind": "LinkedField",
      "name": "queueSlot",
      "plural": false,
      "selections": [
        {
          "alias": "bookings",
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": {
                "direction": "ASC",
                "field": "REQUESTED_DATE_TIME"
              }
            }
          ],
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "__queueSlot_bookings_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "StandardBooking",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "LessonBooking",
                      "abstractKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "WaitlistBooking_Booking"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "__queueSlot_bookings_connection(orderBy:{\"direction\":\"ASC\",\"field\":\"REQUESTED_DATE_TIME\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agenda",
  "abstractKey": null
};
})();

(node as any).hash = "3b080d06384fd5884db62c71811559ce";

export default node;
